import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="relative flex w-full flex-col items-center justify-center px-4 pb-24 pt-40 text-center">
        <p className="font-heading text-[96px] font-bold leading-none text-background-300">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">这个页面不存在</h1>
        <p className="mt-3 font-label text-xs text-foreground-500">{location.pathname}</p>
        <p className="mt-4 max-w-md font-body text-sm leading-relaxed text-foreground-600">
          链接可能已经变更，或者这部影片暂时不在片单中。可以回到首页继续浏览，或通过分类与搜索找到想看的内容。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 font-label text-sm text-background-50 transition-colors hover:bg-accent-600"
          >
            回到首页
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/category"
            className="flex h-10 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 font-label text-sm text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-500"
          >
            浏览分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}